const PREFERRED_ORG_PREFIX = 'catalyx_preferred_org_id';
const LEGACY_PREFERRED_ORG_KEY = PREFERRED_ORG_PREFIX;

export function preferredOrgStorageKey(userId: number | string): string {
  return `${PREFERRED_ORG_PREFIX}:${userId}`;
}

export function getPreferredOrgId(userId: number | string): string | null {
  return localStorage.getItem(preferredOrgStorageKey(userId));
}

export function setPreferredOrgId(userId: number | string, orgId: number | string): void {
  localStorage.setItem(preferredOrgStorageKey(userId), String(orgId));
}

export function clearPreferredOrg(userId?: number | string | null): void {
  if (userId != null) {
    localStorage.removeItem(preferredOrgStorageKey(userId));
  }
  localStorage.removeItem(LEGACY_PREFERRED_ORG_KEY);
}
